'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _pageFrame = require('@zillow/page-frame');

var _constants = require('../../utils/constants');

var _userSessionStore = require('@zillow/user-session-store');

var _reactRedux = require('react-redux');

var _universalAnalytics = require('@zillow/universal-analytics');

var _appUpsellLoader = require('@zillow/app-upsell-loader');

var _appUpsellLoader2 = _interopRequireDefault(_appUpsellLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
    This file is webpack'd to work on the browser.
    This is the script that reattaches the Page Header React Component
    to the rendered markup once both are sent to the client.
*/

var hydrateTopNav = function hydrateTopNav() {
    var document = global.window.document;

    var jsonDataNode = document.getElementById(_constants.TOP_NAV_JSON);
    var mainParamNode = document.getElementById(_constants.MAIN_PARAMS_ID);
    var extServiceNode = document.getElementById(_constants.EXT_SERVICE_HOST_ID);
    var userAsyncNode = document.getElementById(_constants.USER_ASYNC_ID);
    var drawerOnlyNode = document.getElementById(_constants.DRAWER_ONLY);
    var mainAsyncNode = document.getElementById(_constants.MAIN_ASYNC_ID);
    var versionHashNode = document.getElementById(_constants.VERSION_HASH_ID);
    var topNavAnchor = document.getElementById(_constants.TOP_NAV_WRAPPER);
    var drawerOnly = drawerOnlyNode && drawerOnlyNode.innerHTML === 'true';
    var userAsync = userAsyncNode && userAsyncNode.innerHTML === 'true';
    var authLabels = {
        '/user/acct/login/': 'topnav/signin',
        '/user/acct/register/': 'topnav/join'
    };

    var pageHeaderProps = {
        userAsync: userAsync,
        links: jsonDataNode ? JSON.parse(jsonDataNode.textContent) : {},
        mainAsync: mainAsyncNode && mainAsyncNode.innerHTML === 'true',
        mainEndpoint: extServiceNode ? extServiceNode.innerHTML : '',
        mainEndpointParams: mainParamNode ? JSON.parse(mainParamNode.innerHTML) : {},
        mainEndpointVersion: versionHashNode ? versionHashNode.innerHTML : '',
        drawerOnly: drawerOnly,
        onLinkClick: function onLinkClick(e) {
            var link = e && e.currentTarget;
            var regLoginAnchor = document.getElementById(_constants.LOGIN_ANCHOR_ID);
            if (link) {
                // If the reg login is detected on the page and the link attempts to direct to a login page,
                // intercept the click and instead show the reg login lightbox
                if (regLoginAnchor && link.pathname.indexOf('/user/acct/') === 0) {
                    e.preventDefault();
                    e.stopPropagation();
                    var label = authLabels[link.pathname];
                    (0, _userSessionStore.setRegLoginPath)(link.pathname);
                    (0, _userSessionStore.setRegLoginUiConfig)({ gaLabel: label });
                    (0, _userSessionStore.showRegLoginLightbox)();
                    // UA tracking for reg links
                    (0, _universalAnalytics.trackEvent)({ category: 'auth', action: 'authopen//', label: label });
                } else {
                    // UA tracking for all non-reg links
                    (0, _universalAnalytics.trackEvent)({ category: 'TopNav', action: link.getAttribute('data-za-action') });
                }
            }
        }
    };

    // Set User Session Store's 'loggedIn' bool to true, if userAsync is true.
    // Ideally, this would be set on the client external to this (because if userAsync is true,
    // one can assume with current logic that the client to PFS KNOWS that the user is logged in). But currently
    // nothing does this and loggedIn defaults to false on page load / creation of a new user session store.
    if (userAsync) {
        (0, _userSessionStore.createUserSessionStore)();
        (0, _userSessionStore.setUserLoggedIn)();
    }

    // Map UserAsync prop to the user session store's logged in value, to determine if a user nav
    // call should be made at any point in the future
    var mapStateToProps = function mapStateToProps(state) {
        return {
            userAsync: state.user.loggedIn
        };
    };

    if (topNavAnchor) {
        var ConnectedPageHeaderAsync = (0, _reactRedux.connect)(mapStateToProps)(_pageFrame.PageHeaderAsync);

        (0, _reactDom.hydrate)(_react2.default.createElement(ConnectedPageHeaderAsync, (0, _extends3.default)({}, pageHeaderProps, { store: (0, _userSessionStore.createUserSessionStore)() })), topNavAnchor);
    }
};

var renderUpsell = function renderUpsell() {
    var document = global.window.document;

    var upsellNode = document.getElementById(_constants.UPSELL_ID);
    var configNode = document.getElementById(_constants.UPSELL_CONFIG_ID);
    var config = configNode ? JSON.parse(configNode.innerHTML) : {};

    var upsellProps = {
        treatment: config.treatment,
        forceTreatment: config.forceTreatment
    };

    if (config.renderUpsell) {
        (0, _reactDom.render)(_react2.default.createElement(_appUpsellLoader2.default, upsellProps), upsellNode);
    }
};

hydrateTopNav();

renderUpsell();


//////////////////
// WEBPACK FOOTER
// ./lib/client-assets/scripts/topnav.js
// module id = 449
// module chunks = 1